<template>
  <div class="entry_btn c-custom_entry_btn" v-if="!$store.state.left_sidebar.dialogVisible">
    <div class="func_entry_overlayer"></div>
    <div class="func_entry_btn func_entry_btn_module" @click="open_left_sidebar('module')">
      <div class="func_entry_icon func_entry_icon_module module"></div>
      <span class="func_entry_text">{{$t('view_left_sidebar_btn_108')}}</span>
    </div>
    <div class="func_entry_btn func_entry_btn_module" @click="open_left_sidebar('page')"
      v-if="$store.state.app.role === 'designer'">
      <div class="func_entry_icon func_entry_icon_module page"></div>
      <span class="func_entry_text">{{$t('view_left_sidebar_btn_109')}}</span>
    </div>
    <div class="func_entry_btn func_entry_btn_module" @click="open_left_sidebar('style')">
      <div class="func_entry_icon func_entry_icon_module style"></div>
      <span class="func_entry_text">{{$t('view_left_sidebar_btn_110')}}</span>
    </div>
    <div class="func_entry_btn func_entry_btn_module" @click="open_left_sidebar('set')">
      <div class="func_entry_icon func_entry_icon_module set"></div>
      <span class="func_entry_text">{{$t('view_public_topbar_4')}}</span>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import { getFshopRole } from '@/api/app';

export default {
  name: "btn",
  watch: {
    '$store.state.left_sidebar.dialogVisible'(val) {
      if (!val) {
        this.$nextTick(() => {
          $('.entry_btn').css({ top: `${this.top}px`, left: `${this.left}px` })
          this.draggableEntryBtn()
        })
      } else {
        $('.entry_btn').draggable("destroy");
      }
    }
  },
  data() {
    return {
      top: 280,
      left: 56
    }
  },
  mounted() {
    this.draggableEntryBtn()
    this.getUserLoginConfig() // 注释掉登录注册的请求接口
  },
  methods: {
    open_left_sidebar(active) {
      this.$store.commit('left_sidebar/set_dialog', true)
      this.$store.commit('left_sidebar/set_active', active)
    },
    draggableEntryBtn() {
      const _this = this
      $('.entry_btn').draggable({
        containment: 'window',
        cursor: 'move',
        start: function (event, ui) {
          $('.func_entry_overlayer').css({ display: 'block' })
        },
        stop: function (event, ui) {
          _this.top = ui.position.top
          _this.left = ui.position.left
          $('.func_entry_overlayer').css({ display: 'none' })
        }
      })
    },
    async getUserLoginConfig() { // 获取是否设置注册登录
      let res = await getFshopRole();
      if (res.code === 200) {
        if (res.data) {
          this.$store.commit('login_type/set_register_set', true)
        }
        // let is_set = res.data.is_set ? true : false
        // if (!is_set) return;
        // let reg_way = res.data.reg_way
        // let arr = [];
        // for (let key in reg_way) {
        //   if (reg_way[key]) arr.push(key)
        // }
        // this.$store.commit('login_type/set_login_type', arr)
      } else this.$message.error(res.message)
    }
  }
}
</script>

<style lang="scss" scoped>
.entry_btn {
  width: 54px;
  position: fixed;
  z-index: 1998;
  left: 56px;
  top: 280px;
  cursor: move;
  background: #fff;
  box-shadow: 1px 3px 8px 0px rgba(0, 0, 0, 0.07);
  border-radius: 4px;

  .func_entry_overlayer {
    display: none !important;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: 0 0;
    z-index: 9;
  }

  .func_entry_btn {
    overflow: hidden;
    display: block;
    margin-bottom: 10px;
    width: 56px;
    line-height: 0;
    cursor: pointer;
    transition: background-color, width .2s;
    text-align: center;
    height: 72px;

    &:last-child {
      margin-bottom: 0px;
    }

    .func_entry_icon {
      display: inline-block;
      width: 54px;
      height: 54px;
      line-height: 54px;
      //margin-left: 13px;
      font-size: 0;

      &:before {
        content: "";
        display: inline-block;
        vertical-align: middle;
        height: 30px;
        width: 30px;
        background-size: cover;
        background-repeat: no-repeat;
      }

      &.module {
        cursor: pointer;
      }

      &.module:before {
        background-image: url("/static/image/leftbar/icon-module-dark@2x.png");
        //background-position: -562px -195px;
      }

      &.page:before {
        background-image: url("/static/image/leftbar/icon-page-dark@2x.png");
        //background-position: -674px -195px;
      }

      &.style:before {
        background-image: url("/static/image/leftbar/icon-style-dark@2x.png");
        //background-position: -618px -195px;
      }

      &.set:before {
        background-image: url("/static/image/leftbar/icon-setting-dark@2x.png");
        //background-position: -674px -195px;
      }
    }

    .func_entry_text {
      //height: 54px;
      //margin-left: -17px;
      //line-height: 54px;
      color: #636978;
      font-size: 15px;
      font-family: "微软雅黑";
      white-space: nowrap;
      vertical-align: top;
    }

    &:hover {
      //width: 100px;
      background-color: rgba(61, 138, 255, 0.1);

      .func_entry_text {
        color: rgba(61, 138, 255, 1);
      }

      .func_entry_icon {
        &.module:before {
          background-image: url("/static/image/leftbar/icon-module-blue@2x.png");
        }

        &.page:before {
          background-image: url("/static/image/leftbar/icon-page-blue@2x.png");
        }

        &.style:before {
          background-image: url("/static/image/leftbar/icon-style-blue@2x.png");
        }

        &.set:before {
          background-image: url("/static/image/leftbar/icon-setting-blue@2x.png");
        }
      }

      .func_entry_text {
        display: inline-block;
      }
    }

    //hover的时候，背景图片第一次加载需要时间，不会马上显示出来，看上去会闪烁一下，用户体验不好，放在伪元素里让它预先加载一次

    .func_entry_icon {
      &:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        opacity: 0;
      }

      &.module:after {
        background-image: url("/static/image/leftbar/icon-module-blue@2x.png");
      }

      &.page:after {
        background-image: url("/static/image/leftbar/icon-page-blue@2x.png");
      }

      &.style:after {
        background-image: url("/static/image/leftbar/icon-style-blue@2x.png");
      }

      &.set:after {
        background-image: url("/static/image/leftbar/icon-setting-blue@2x.png");
      }
    }
  }

  &.c-custom_entry_btn {
    .func_entry_btn {
      width: auto;
      min-width: 56px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/left_sidebar/btn.vue